import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';

async function getAvailableDatasets(
  auth: Authentication | null,
): Promise<string[]> {
  try {
    if (!auth) throw new GetAvailableDatasetsFailure('Vous devez être connecté pour effectuer cette action.', 'unauthorized');

    const response = await HttpClient.get(
      `/backoffice/demoaccount/datasets`,
      auth.token
    );

    if(!response.success) throw new GetAvailableDatasetsFailure(response.message, response.code);
    return response.data;
  } catch (e) {
    if (e instanceof GetAvailableDatasetsFailure) throw e;
    throw new GetAvailableDatasetsFailure();
  }
}

export class GetAvailableDatasetsFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getAvailableDatasets;
